import React from 'react';
import { Keyboard, Platform, Pressable, StyleSheet, View } from 'react-native';
import { Image } from 'expo-image';
import { useRouter } from 'expo-router';
import { useTheme } from '@/context/ThemeContext';
import { useAuthStore } from '@/store/auth';
import { useOnboardingStore } from '@/store/onboarding';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

export default function PersonalOnboardingInvitation({ compact = false }) {
  const router = useRouter();
  const { colors, theme } = useTheme();
  const light = theme === 'white';
  const accent = light ? '#206B49' : '#A4D9B4';
  const label = 'Personalize my AI';
  const open = () => {
    const { user, token } = useAuthStore.getState();
    if (!user?.id || !token || user.flags?.isGhost) return;
    Keyboard.dismiss();
    if (Platform.OS === 'web') useOnboardingStore.getState().actions.startOnboarding({ userId: user.id });
    else router.push({ pathname: '/(auth)/onboarding', params: { source: 'personalization' } });
  };
  return <Pressable accessibilityRole="button" accessibilityLabel={label}
    accessibilityHint="Tell Gab AI a bit about you and see Chat and Work"
    onPress={open} style={({ hovered, pressed }) => [styles.card, {
      backgroundColor: light ? '#F4F8F1' : colors.solid_color_secondary,
      borderColor: light ? '#D9E7D9' : colors.border_color_secondary,
      opacity: pressed ? 0.8 : 1,
    }, hovered && { borderColor: accent }, compact && styles.compact]}>
    <View style={styles.row}>
      <Image source={require('@/assets/images/onboarding/pixel-welcome.webp')} contentFit="contain"
        accessible={false} style={{ width: compact ? 48 : 64, height: compact ? 48 : 64 }} />
      <View style={styles.copy}>
        <Text weight="bold" style={{ fontSize: compact ? 16 : 18, lineHeight: 23 }}>Make Gab AI yours</Text>
        <Text color="secondary" style={styles.description}>Tell Gab AI what you do, then see Chat, Work, and how Plus can help.</Text>
        <View style={styles.action}>
          <Text weight="bold" style={{ color: accent, fontSize: 14, lineHeight: 20 }}>{label}</Text>
          <Icon name="arrow-right" size={13} color={accent} />
        </View>
      </View>
    </View>
  </Pressable>;
}

const styles = StyleSheet.create({
  card: { width: '100%', borderRadius: 20, borderWidth: 1, padding: 20, marginBottom: 16, flexShrink: 0 },
  compact: { padding: 16 },
  row: { flexDirection: 'row', alignItems: 'center', gap: 14 },
  copy: { flex: 1, minWidth: 0, gap: 4 },
  description: { fontSize: 14, lineHeight: 20 },
  action: { flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginTop: 4, minHeight: 24 },
});
